import { Card, Grid, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import { useNavigate } from "react-router-dom";
import ProjectMapsList from "modules/projectMaps/ProjectMapsList";
import useCreateProjectMap from "hooks/projectMaps/useCreateProjectMap";
import SaveProjectMapModal from "modules/projectMaps/SaveProjectMapModal";
import { AI_MAPPING_JUST_CREATED_KEY } from "modules/aiMapping";
import { useCallback, useState } from "react";

export default function ProjectMapsPage() {
  const navigate = useNavigate();
  const [createProjectMap] = useCreateProjectMap();
  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [aiIntent, setAiIntent] = useState(false);

  const handleCreate = useCallback(
    async (name: string) => {
      setSaving(true);
      try {
        const result = await createProjectMap({
          variables: { input: { name } },
        });
        const newMap = result?.data?.createProjectMap;
        if (newMap?.id) {
          if (aiIntent) {
            navigate(`/map/${newMap.id}`);
          } else {
            try {
              sessionStorage.setItem(AI_MAPPING_JUST_CREATED_KEY, newMap.id);
            } catch {
              /* ignore storage errors */
            }
            navigate(`/map/${newMap.id}`);
          }
        }
        setModalOpen(false);
        setAiIntent(false);
      } finally {
        setSaving(false);
      }
    },
    [createProjectMap, navigate, aiIntent]
  );

  const openAiMapping = useCallback(() => {
    setAiIntent(true);
    setModalOpen(true);
  }, []);

  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                display="flex"
                alignItems="center"
                width="100%"
                justifyContent="space-between"
              >
                <MDTypography variant="h4" fontWeight="medium">
                  Maps
                </MDTypography>
                <MDBox display="flex" alignItems="center" gap={2}>
                  <MDButton color="dark" variant="gradient" onClick={openAiMapping}>
                    Map with AI
                  </MDButton>
                  <MDButton color="blue" onClick={() => setModalOpen(true)}>
                    <Icon>add</Icon>&nbsp; New Map
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ProjectMapsList />
        </Grid>
      </Grid>
      <SaveProjectMapModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setAiIntent(false);
        }}
        onSave={handleCreate}
        saving={saving}
      />
    </DashboardPage>
  );
}
